// const backendDomain = "http://192.168.1.112/oakya_food"
// const backendDomain = "http://192.168.1.254/oakya_dev/sguaccounts/api"
const backendDomain = "https://oakyafoodaccounts.sanjayghodawat.co.in/api"           

const SummaryApi = {
    createStudent : {
        url : `${backendDomain}/student/student_create.php`,
        method : "POST"
    },
    updateStudent : {
        url : `${backendDomain}/student/student_update.php`,
        method : "POST"
    },
    getAllStudents : {    
        url : `${backendDomain}/student/student_retrieve.php`,
        method : "GET"
    },                                     
}     
                                                                                         
export default SummaryApi;     

     








